module.exports = __webpack_public_path__ + "static/23-tat1-2743908656ae2e1c149313f2d26b8a8e.jpg";